// Make sure this file is safe to run from scripts

// We need this to allow app-e2e to be compiled as it does not know about window.ENV otherwise
/// <reference path="../scripts/script-types.d.ts" />

import { browserStackLocalUrl } from '../../shared/cfg/browserStack.no-deps'
import { ports } from '../../shared/cfg/ports.no-deps'
import { LS_authUrlGet } from './LS/LS.authUrl'

export const versionName = 'Castlefield'
export const authUrl = getAuthUrl()

export function getAuthUrl() {
    if (typeof window !== 'object') return 'https://sso.zaptic.com'

    if (window.ENV.useBrowserStackLocal) {
        return `http://${browserStackLocalUrl}:${ports.auth}`
    }

    // prettier-ignore
    const fallback =
        window.ENV.isProduction ? 'https://sso.zaptic.com' :
        window.ENV.isTest ? `http://localhost:${ports.auth}` :
            'https://dev-sso.zaptic.com'

    return LS_authUrlGet() || fallback
}

export const keys = {
    graphHopper: 'b9c608c3-d51a-476a-93e4-e34669616545',
    mapQuest: 'FcvlqtS6LrH8tLhfj07WN3aUicuviqmX',
    sentry: 'https://6517dfa5d7fc48f8bff84456dc5814b8@sentry.io/109915',
    codePush: {
        prod: {
            iOS: 'oYItrJi4weCG9xNELpNWL06c801O506a0903-905d-464b-b4a0-6048cbb68a72',
            android: 'VkfsXER7bkv002kbsTn_4mtbsodL506a0903-905d-464b-b4a0-6048cbb68a72',
        },
        dev: {
            iOS: 'kFekb4knlH4Bt75jCSJwzZAIHPJf416EpPeDG',
            android: 'Fl7ziYTErEXZZz2KZ3YpN3abvuQW416EpPeDG',
        },
        lts: {
            iOS: 'UFONQ3APe4_hdDg8aPBQpPNUIMaA416EpPeDG',
            android: 'A7X8BW58X7wv3Pa9VwCllNj8eOo7416EpPeDG',
        },
    },
}
